<template>
  <div class="mt-5 pt-2">
    <a-row class='justify-content-center pb-5'>
      <img
      width="284"
        src="https://upload.wikimedia.org/wikipedia/commons/9/97/Holcim_Logotipo.png"
        alt="Holcim México"
      >
    </a-row>

    <div class="card" :class="$style.container">
      <a-row>
        <a-col span="4" offset="20">
          <a-button type="info" class="text-right" @click="changeLoginType">
            <strong>
              <i class="fa fa-user-circle" v-if="loginGoogle" />
              <i class="fa fa-google" v-else />
            </strong>
          </a-button>
        </a-col>
      </a-row>

      <div class="text-holcim-dark-blue font-weight-bold font-size-32 text-center">
        Carta Porte Holcim
      </div>
      <hr class="bg-holcim-bright-blue mb-2" />
      <div class="mb-4 text-justify text-holcim-dark-blue">
        Diseñada para la administración y consulta de las Cartas Porte de Holcim México.
      </div>

      <a-form v-if="!loginGoogle" :rules="rules" layout="vertical" class="mb-4 mt-2" :model="loginForm"
        @finish="handleFinish" @finishFailed="handleFinishFailed">
        <a-form-item name="email">
          <a-input v-model:value="loginForm.email" placeholder="Email" />
        </a-form-item>
        <a-form-item name="password" :validate-status="apiError ? 'error' : ''" :help="apiError || ''">
          <a-input v-model:value="loginForm.password" placeholder="Password" type="password" />
        </a-form-item>
        <a-button :loading="loading" html-type="submit" class="bg-holcim-bright-green text-center w-100">
          <strong class="text-white">
            <i class="fa fa-google" />
            Ingresar a la Aplicación
          </strong>
        </a-button>
        <hr>
      </a-form>

      <a-button v-else :loading="loading" @click="handleClickSignIn" class="bg-holcim-bright-green text-center w-100">
        <strong class="text-white">
          <i class="fa fa-google" />
          Ingresar a la Aplicación
        </strong>
      </a-button>

    </div>
  </div>
</template>
<script>
import { computed, inject, reactive, ref } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'VbLogin',
  setup() {
    const store = useStore()
    const settings = computed(() => store.getters.settings)
    const loading = computed(() => store.getters['user/user'].loading)
    const apiError = ref('')
    const rules = {
      email: [
        {
          required: true,
          message: 'Por favor ingrese un email válido',
          trigger: 'change',
        },
      ],
      password: [{ required: true, message: 'Por favor ingrese su contraseña', trigger: 'change' }],
    }
    const loginForm = reactive({
      email: '',
      password: '',
    })
    let loginGoogle = ref(true)

    const changeAuthProvider = value => {
      store.commit('CHANGE_SETTING', { setting: 'authProvider', value })
    }
    const handleFinish = async values => {
      apiError.value = ''
      try {
        await store.dispatch('user/LOGIN', { payload: values })
      } catch (e) {
        apiError.value = e?.message || 'Credenciales inválidas'
      }
    }
    const handleFinishFailed = errors => {
      console.log(errors)
    }

    const Vue3GoogleOauth = inject("Vue3GoogleOauth")

    return {
      Vue3GoogleOauth,

      settings,
      loading,
      rules,
      loginForm,
      changeAuthProvider,
      handleFinish,
      handleFinishFailed,

      loginGoogle,
      apiError,
    }
  },
  methods: {
    changeLoginType() {
      this.loginGoogle = !this.loginGoogle
    },

    async handleClickSignIn() {
      try {

        const googleUser = await this.$gAuth.signIn()
        if (!googleUser) {
          return null
        }

        const { id_token } = googleUser.getAuthResponse()
        await this.$store.dispatch('user/GOOGLELOGIN', { payload: id_token })

      } catch (error) {

        console.error(error)
        return null

      }
    },

    async handleClickSignOut() {
      try {
        await this.$gAuth.signOut();
        console.log("isAuthorized", this.Vue3GoogleOauth.isAuthorized);
      } catch (error) {
        console.error(error);
      }
    },
  },
}
</script>
<style lang="scss" module>
@import '@/@vb/components/Auth/style.module.scss';
</style>
